/*
 * Copyright (c) 2016 Omnigon Communications, LLC. All rights reserved.
 *
 * This software is the confidential and proprietary information of Omnigon Communications, LLC
 * ("Confidential Information"). You shall not disclose such Confidential Information and shall access and use it only
 * in accordance with the terms of the license agreement you entered into with Omnigon Communications, LLC, its
 * subsidiaries, affiliates or authorized licensee. Unless required by applicable law or agreed to in writing, this
 * Confidential Information is provided on an "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either
 * express or implied. See the license agreement for the specific language governing permissions and limitations.
 */

var can = require('can');
var _ = require('lodash');

module.exports = function () {
    return {
        safeString: function (str) {
            var safeString = can.stache.safeString(str);
            return Object.create(safeString, {
                factory: {
                    writable: false,
                    value: can.stache.safeString
                },
                string: {
                    writable: false,
                    value: str
                }
            });
        },
        unwrapSafeString: function (str) {
            return str.factory === can.stache.safeString ? str.string : str;
        },
        i18n: function (str) {
            if (_.isString(str) && window.i18n && window.i18n[str]) {
                return window.i18n[str];
            }
            return str;
        }
    };
};
